import angular from 'angular'
import './blockchain_address/blockchain_address.controller'
import './blockchain_address/blockchain_address.service'
import './cash_ledger/cash_ledger.controller'
import './cash_ledger/bundle/bundle.controller'
import './collections/collections.controller'
import './collections/collections.service'
import './collections/prints/prints.controller'
import './collections/sets/sets.controller'
import './comments/comments.controller'
import './devices/devices.controller'
import './email_changes/email_changes.controller'
import './email_changes/email_changes.service'
import './favorites/favorites.controller'
import './friends/friends.controller'
import './inviters/inviters.controller'
import './ips/ips.controller'
import './items/items.controller'
import './ledger/ledger.controller'
import './ledger/bundle/bundle.controller'
import './listing_buyer/listing_buyer.controller'
import './listing_seller/listing_seller.controller'
import './messages/messages.controller'
import './messages/details/details.controller'
import './notes/notes.controller'
import './print_escrows/print_escrows.controller'
import './profile/profile.controller'
import './promocodes/promocodes.controller'
import './purchases/purchases.controller'
import './purchases/purchases.service'
import './reports/reports.controller'
import './restrictions/restrictions.controller'
import './roles/roles.controller'
import './roles/roles.service'
import './shelfies/shelfies.controller'
import './showcases/showcases.controller'
import './trades/trades.controller'
import './trades/details/details.controller'
import './user_lock_logs/user_lock_logs.controller'
import './user_lock_logs/user_lock_logs.service'
import './username_changes/username_changes.controller'
import './username_changes/username_changes.service'
import './wallets/wallets.controller'
import './wallets/wallets.service'

angular
  .module('admin.users.details', [
    'admin.users.details.reports',
    'admin.users.details.comments',
    'admin.users.details.favorites',
    'admin.users.details.messages',
    'admin.users.details.friends',
    'admin.users.details.trades',
    'admin.users.details.listing_buyer',
    'admin.users.details.listing_seller',
    'admin.users.details.purchases',
    'admin.users.details.devices',
    'admin.users.details.items',
    'admin.users.details.inviters',
    'admin.users.details.ledgers',
    'admin.users.details.cash_ledgers',
    'admin.users.details.notes',
    'admin.users.details.restrictions',
    'admin.users.details.showcases',
    'admin.users.details.promocodes',
    'admin.users.details.profile',
    'admin.users.details.shelfies',
    'admin.users.details.ips',
    'admin.users.details.collections',
    'admin.users.details.print_escrows',
    'admin.users.details.wallets',
    'admin.users.details.blockchain_address',
    'admin.users.details.username_changes',
    'admin.users.details.email_changes',
    'admin.users.details.user_lock_logs',
    'admin.users.details.roles',
  ])
  .controller('UserDetailsAdminCtrl', UserDetailsAdminCtrl)

/** @ngInject */
function UserDetailsAdminCtrl(
  $scope,
  $q,
  $sce,
  $state,
  $timeout,
  $rootScope,
  $stateParams,
  UsersService,
  UserCache,
  UploadService,
  WashTradesService,
  CsvService,
) {
  var vm = this
  vm.showcase = {}
  vm.creditStore = {
    credit_type: 1,
    amount: 0,
  }
  vm.items = []
  vm.create = false
  vm.pathImgT = ''
  vm.model = {}
  vm.note = null
  vm.shippingAddress = null
  vm.durs = [
    {
      t: 'Forever',
      val: '',
    },
    {
      t: '1 hour',
      val: '1h',
    },
    {
      t: '4 hour',
      val: '4h',
    },
    {
      t: '8 hour',
      val: '8h',
    },
    {
      t: '24 hour',
      val: '24h',
    },
    {
      t: '3 days',
      val: '72h',
    },
    {
      t: '1 week',
      val: '168h',
    },
    {
      t: '2 weeks',
      val: '336h',
    },
  ]

  vm.reasons = [
    {
      t: 'Bullying',
      val: 'Bullying',
    },
    {
      t: 'Cursing',
      val: 'Cursing',
    },
    {
      t: 'Bad username',
      val: 'Bad username',
    },
    {
      t: 'Bad user photo',
      val: 'Bad user photo',
    },
    {
      t: 'Soliciting',
      val: 'Soliciting',
    },
    {
      t: 'Fraud',
      val: 'Fraud',
    },
    {
      t: 'Other',
      val: 'Other',
    },
  ]

  vm.creditTypes = [
    {
      id: 1,
      t: 'Primary Market',
    },
    {
      id: 2,
      t: 'Primary and Aftermarket',
    },
  ]
  // vm.img = undefined;

  function loadNote() {
    UsersService.listNotesLimit($stateParams.parentId).then(function (result) {
      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i].ts !== undefined) {
          result.results[i].ts = new Date(
            parseInt(
              result.results[i].ts
                .toString()
                .substring(0, result.results[i].ts.toString().length - 3),
            ),
          )
        }
      }
      vm.notes = result.results
    })
  }

  function load() {
    UsersService.get($stateParams.parentId).then(success)

    function success(result) {
      vm.model = {}
      vm.model = result.results
      if (vm.model['ip-signup']) {
        vm.model['ip-signup-crypto'] = vm.encrypt(vm.model['ip-signup'].toString())
      }
      var bday, age
      if (vm.model.bday !== undefined && vm.model.bday !== null) {
        bday = new Date(
          parseInt(vm.model.bday.toString().substring(0, vm.model.bday.toString().length - 3)),
        )
        vm.model.bday = moment(bday).format('LL')

        vm.model.age = parseInt(moment(bday).format('LL').split(',')[1].trim())
        var year = new Date().getFullYear()
        var monthNow = new Date().getMonth()
        var monthUser = new Date(bday).getMonth()
        var dayNow = new Date().getDate()
        var dayUser = new Date(bday).getDate()
        if (vm.model.age < year) {
          vm.model.age = year - vm.model.age
        } else {
          vm.model.age = vm.model.age - year
        }

        if (monthUser > monthNow) {
          vm.model.age = vm.model.age - 1
        }

        if (vm.model['img-cover'].indexOf('mp4') !== -1) {
          vm.model.isVideo = true
          vm.model.video = $sce.trustAsResourceUrl($rootScope.urlS3 + '/' + vm.model['img-cover'])
        } else {
          vm.model.isVideo = false
        }
      }

      localStorage.setItem('search', vm.model.username)
      if (vm.model.ts !== undefined && vm.model.ts !== null) {
        vm.model.ts = new Date(
          parseInt(vm.model.ts.toString().substring(0, vm.model.ts.toString().length - 3)),
        )
      }
      if (vm.model['ts-m'] !== undefined && vm.model['ts-m'] !== null) {
        vm.model['ts-m'] = new Date(
          parseInt(
            vm.model['ts-m'].toString().substring(0, vm.model['ts-m'].toString().length - 3),
          ),
        )
      }

      if (vm.model.blurb.length > 35) {
        vm.model.blurb1 = vm.model.blurb.substring(35, vm.model.blurb.length)
        vm.model.blurb = vm.model.blurb.substring(0, 35)
      }

      vm.pfp = null
      if (vm.model.pfp) {
        UsersService.getPrintPublic(vm.model.pfp.id).then(function (resultPfp) {
          vm.pfp = resultPfp.results
          console.log(vm.pfp)
        })
      }
    }

    UsersService.getShowcase($stateParams.parentId).then(function (result) {
      vm.showcase = result.results
    })

    UsersService.getShippingAddress($stateParams.parentId).then(function (result) {
      vm.shippingAddress = result.results
    })

    WashTradesService.list(0, 200, '', $stateParams.parentId, '', '', '', '').then(
      function (result) {
        var listingCount = 0
        for (var i = 0; i < result.results.length; i++) {
          listingCount += result.results[i].li.length
        }
        vm.washTrades = listingCount
      },
    )
  }

  load()
  loadNote()

  vm.verify = function () {
    if (vm.model.verified === 0 || vm.model.verified === 3) {
      swal(
        {
          title: 'Verify Account?',
          text: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            UsersService.verify(vm.model.id).then(
              function () {
                vm.model.verified = 1
                swal('Verified user', '', 'success')
              },
              function (err) {
                swal(err.error.message, '', 'error')
              },
            )
          } else {
            return
          }
        },
      )
    } else {
      $state.go('admin.users.details.email_changes', {
        parentId: vm.model.id,
      })
    }
  }

  vm.verifyEmail = function () {
    swal(
      {
        title: 'Verify Email Account?',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.verifyEmail(vm.model.id).then(
            function (res) {
              vm.model['ts-ev'] = res.results['ts-ev']
              swal('Verified user', '', 'success')
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.modalTOS = function () {
    $('#modalTOS').modal('show')
  }

  vm.saveTOS = function () {
    swal(
      {
        title: 'Accept TOS?',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.tos(vm.model.id, vm.tos).then(
            function () {
              load()
              swal('TOS accepted', '', 'success')
              $('#modalTOS').modal('hide')
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.uploadT = function (item) {
    item.loadT = true
    UploadService.save('users', vm.pathImgT, 'img', item.id).then(function (fileName) {
      item.loadT = false
      item.img = fileName
    })
  }

  vm.addCoins = function () {
    swal(
      {
        title: 'Adjust Coins',
        text: 'Amount of coins',
        type: 'input',
        showCancelButton: true,
        closeOnConfirm: false,
        animation: 'slide-from-top',
        inputPlaceholder: 'Coins',
        inputValue: 0,
      },
      function (inputValue) {
        if (inputValue === false) {
          return false
        }
        if (inputValue === '') {
          swal.showInputError('You need to write something!')
          return false
        }
        if (isNaN(parseInt(inputValue))) {
          swal.showInputError('You need to write numbers!')
          return false
        }

        var msg = ''
        if (parseInt(inputValue) >= 0) {
          msg = 'Adding Coins'
        } else {
          msg = 'Deducting Coins'
        }

        swal(
          {
            title: msg,
            text: 'Are you sure ?',
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: true,
            closeOnCancel: true,
            animation: 'slide-from-top',
          },
          function (isConfirm) {
            if (isConfirm) {
              UsersService.addCoins(vm.model.id, {
                coins: parseInt(inputValue),
              }).then(
                function () {
                  if (vm.model.c === undefined) {
                    vm.model.c = parseInt(inputValue)
                  } else {
                    vm.model.c = vm.model.c + parseInt(inputValue)
                  }
                  swal.close()
                },
                function (err) {
                  var e = err.error.message.split(';')
                  var html = ''
                  for (var i = 0; i < e.length; i++) {
                    html +=
                      '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                  }
                  $timeout(function () {
                    swal({
                      title: 'Adding Coins',
                      text: html,
                      html: true,
                    })
                  }, 500)
                },
              )
            } else {
              return
            }
          },
        )
      },
    )
  }

  vm.addCashs = function () {
    swal(
      {
        title: 'Adjust Cash',
        text: 'Amount of cash',
        type: 'input',
        showCancelButton: true,
        closeOnConfirm: false,
        animation: 'slide-from-top',
        inputPlaceholder: 'Cash',
        inputValue: 0,
      },
      function (inputValue) {
        if (inputValue === false) {
          return false
        }
        if (inputValue === '') {
          swal.showInputError('You need to write something!')
          return false
        }
        if (isNaN(parseFloat(inputValue))) {
          swal.showInputError('You need to write numbers!')
          return false
        }

        var msg = ''
        if (parseFloat(inputValue) >= 0) {
          msg = 'Adding Cash'
        } else {
          msg = 'Deducting Cash'
        }

        swal(
          {
            title: msg,
            text: 'Are you sure ?',
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: true,
            closeOnCancel: true,
            animation: 'slide-from-top',
          },
          function (isConfirm) {
            if (isConfirm) {
              UsersService.addCash(vm.model.id, {
                amount: parseFloat(inputValue),
              }).then(
                function () {
                  if (vm.model.bal === undefined) {
                    vm.model.bal = parseFloat(inputValue)
                  } else {
                    vm.model.bal = vm.model.c + parseFloat(inputValue)
                  }
                  swal.close()
                },
                function (err) {
                  var e = err.error.message.split(';')
                  var html = ''
                  for (var i = 0; i < e.length; i++) {
                    html +=
                      '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                  }
                  $timeout(function () {
                    swal({
                      title: 'Adding Cash',
                      text: html,
                      html: true,
                    })
                  }, 500)
                },
              )
            } else {
              return
            }
          },
        )
      },
    )
  }

  vm.openStoreCredit = function () {
    $('#modalAddStoreCredit').modal('show')
  }

  vm.addStoreCredit = function () {
    swal(
      {
        title: 'Adjust Store Credit',
        text: 'Are you sure ?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.addStoreCredit(vm.model.id, {
            amount: parseFloat(vm.creditStore.amount),
            credit_type: parseInt(vm.creditStore.credit_type),
          }).then(
            function () {
              swal.close()
              $('#modalAddStoreCredit').modal('hide')
            },
            function (err) {
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
              }
              $timeout(function () {
                swal({
                  title: 'Adding Store Credit',
                  text: html,
                  html: true,
                })
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.editUser = function () {
    $state.go('admin.users.details.profile', {
      parentId: $stateParams.parentId,
    })
  }

  vm.editPassword = function () {
    swal(
      {
        title: 'Edit Password',
        type: 'input',
        showCancelButton: true,
        closeOnConfirm: false,
        animation: 'slide-from-top',
        inputPlaceholder: 'Password',
        inputValue: '',
        inputType: 'password',
      },
      function (inputValue) {
        if (inputValue === false) {
          return false
        }
        if (inputValue === '') {
          swal.showInputError('You need to write something!')
          return false
        }

        swal(
          {
            title: 'Change password',
            text: 'Are you sure ?',
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: true,
            closeOnCancel: true,
            animation: 'slide-from-top',
          },
          function (isConfirm) {
            if (isConfirm) {
              UsersService.changePassword($stateParams.parentId, {
                password: inputValue,
              }).then(
                function () {
                  swal.close()
                },
                function (err) {
                  $timeout(function () {
                    swal(err.error.message, '', 'error')
                  }, 500)
                  return false
                },
              )
            }
          },
        )
      },
    )
  }

  vm.removePhoto = function () {
    if (vm.model.img === undefined) {
      swal('This user does not have a photo.')
      return
    }

    swal(
      {
        title: 'Remove photo',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $timeout(function () {
            // UploadService.deletePhoto(vm.model.img).then(
            //   function() {
            UsersService.update(vm.model.id, { img: '' }).then(
              function () {
                load()
              },
              function () {
                swal("You don't have permission")
              },
            )
            // },
            // function() {
            //   swal("Error when try delete image in aws");
            // }
            // );
          }, 500)
        } else {
          return
        }
      },
    )
  }

  vm.removeCover = function () {
    if (vm.model.img === undefined) {
      swal('This user does not have a image cover.')
      return
    }

    swal(
      {
        title: 'Remove Cover Photo?',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $timeout(function () {
            UploadService.deletePhotoCover(vm.model['img-cover']).then(
              function () {
                UsersService.update(vm.model.id, { 'img-cover': '' }).then(
                  function () {
                    load()
                  },
                  function () {
                    swal("You don't have permission")
                  },
                )
              },
              function () {
                swal('Error when try delete image in aws')
              },
            )
          }, 500)
        } else {
          return
        }
      },
    )
  }

  vm.report = function () {
    vm.changeUsername = false
    $('#myModal').modal('show')
  }

  vm.clearBalanceCache = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'OK',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.clearBalanceCache($stateParams.parentId).then(
            function () {
              swal('User balance cache cleared')
            },
            function () {
              swal('Error clearing user balance cache')
            },
          )
        }
      },
    )
  }

  vm.saveModal = function () {
    var reason = vm.reason

    if (reason === '' || reason === null || reason === undefined) {
      swal('Suspension Incomplete: Please add a reason', '', 'error')
      return
    }

    if (vm.reason === 'Other') {
      var isPass = true
      if (vm.txt === null || vm.txt === undefined || vm.txt === '') {
        isPass = false
      } else {
        isPass = true
      }

      if (!isPass) {
        if (vm.reason2 === null || vm.reason2 === undefined || vm.reason2 === '') {
          isPass = false
        } else {
          isPass = true
        }
      }

      if (!isPass) {
        swal('Suspension Incomplete: Please add a Reason/Description', '', 'error')
        return
      }
    }

    if (vm.reason2 !== null && vm.reason2 !== undefined && vm.reason2 !== '') {
      reason = vm.reason2
    }

    var model = {
      txt: vm.txt,
      dur: vm.dur,
      reason: reason,
    }
    if (model.dur === '' || model.dur === null || model.dur === undefined) {
      delete model.dur
    }
    UsersService.block(vm.model.id, model).then(function () {
      var cache = UserCache.getObject()
      var userId = cache.user.id

      if (vm.changeUsername) {
        var username = 'Guest_' + vm.model.id
        UsersService.changeUsername(vm.model.id, { username: username }).then(function () {})

        var model = {
          'id-u': parseInt($stateParams.parentId),
          'id-a': parseInt(userId),
          txt:
            'Reason: ' +
            reason +
            ' | Old username: ' +
            vm.model.username +
            ' | New Username: ' +
            username +
            ' | Date: ' +
            new Date().toISOString().split('T')[0] +
            ' | Admin: ' +
            cache.user.username,
        }

        UsersService.createNotes($stateParams.parentId, model).then(function () {
          $('#myModal').modal('hide')
          swal('Suspended!', 'The name been changed and note created', 'success')
          load()
          loadNote()
        })
      } else {
        var model2 = {
          'id-u': parseInt($stateParams.parentId),
          'id-a': parseInt(userId),
          txt:
            'Reason: ' +
            reason +
            ' | Username: ' +
            vm.model.username +
            ' | Date: ' +
            new Date().toISOString().split('T')[0] +
            ' | Admin: ' +
            cache.user.username,
        }

        UsersService.createNotes($stateParams.parentId, model2).then(function () {
          $('#myModal').modal('hide')
          swal('Suspended!', 'The name been changed and note created', 'success')
          load()
          loadNote()
        })
      }
    })
  }

  vm.unreport = function (item) {
    UsersService.unblock(vm.model.id).then(function () {
      swal('Unsuspended!', '', 'success')
      load()
    })
  }

  vm.urlLink = function () {
    var urlField = document.querySelector('#urlLink')
    // create a Range object
    var range = document.createRange()
    // set the Node to select the "range"
    range.selectNode(urlField)
    // add the Range to the set of window selections
    window.getSelection().addRange(range)
    //var copied = 'http://app.collectible.co/users/' + vm.model.id;
    document.execCommand('copy')
    toastr.success('Copied!')

    window.getSelection().removeAllRanges()
  }

  vm.appLink = function () {
    var urlField = document.querySelector('#appLink')
    // create a Range object
    var range = document.createRange()
    // set the Node to select the "range"
    range.selectNode(urlField)
    // add the Range to the set of window selections
    window.getSelection().addRange(range)
    //var copied = 'http://app.collectible.co/users/' + vm.model.id;
    document.execCommand('copy')
    toastr.success('Copied!')

    window.getSelection().removeAllRanges()
  }

  vm.saveNotes = function () {
    var cache = UserCache.getObject()
    var userId = cache.user.id
    var model = {
      'id-u': parseInt($stateParams.parentId),
      'id-a': parseInt(userId),
      txt: vm.note,
    }

    UsersService.createNotes($stateParams.parentId, model).then(function () {
      vm.note = null
      loadNote()
    })
  }

  vm.cancelNotes = function () {
    swal(
      {
        title: 'Are you sure?',
        text: 'clear the text field',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'Clear Text',
      },
      function (isConfirm) {
        if (isConfirm) {
          vm.note = null
          $scope.$apply()
        }
      },
    )
  }

  vm.invitedBy = function () {
    if (vm.model.inv !== undefined) {
      $state.go('admin.users.details', { parentId: vm.model.inv.id })
    }
  }

  vm.deletePhone = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'Delete Phone',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.phone(vm.model.id).then(
            function () {
              $state.reload()
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.deleteUser = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'Delete User',
      },
      function (isConfirm) {
        if (isConfirm) {
          if (vm.model.img) {
            // UploadService.deletePhoto(vm.model.img, null).then(
            //   function() {
            // UploadService.deletePhoto(vm.model.img, vm.model.id).then(
            //   function() {
            UsersService.remove(vm.model.id).then(function () {
              $state.go('admin.users')
            })
            //   },
            //   function() {
            //     swal("Error when try delete image in aws");
            //   }
            // );
            // },
            // function() {
            //   swal("Error when try delete image in aws");
            // }
            // );
          } else {
            UsersService.remove(vm.model.id).then(function () {
              $state.go('admin.users')
            })
          }
        }
      },
    )
  }

  vm.deletePost = function () {
    swal(
      {
        title: 'Delete All Trade Posts?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'Ok',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.deleteTradePost(vm.model.id).then(function () {
            swal('All trade posts deleted', '', 'success')
            load()
          })
        }
      },
    )
  }

  vm.deleteBlurb = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'Delete Blurb',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.update(vm.model.id, { blurb: '' }).then(function () {
            load()
          })
        }
      },
    )
  }

  vm.delete2fa = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'Delete 2FA',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.remove2fa(vm.model.id).then(function () {
            load()
          })
        }
      },
    )
  }

  vm.back = function () {
    $state.go('admin.users')
  }

  vm.removeShowcase = function () {
    if (vm.showcase.img === undefined) {
      swal('This user does not have a showcase.')
      return
    }

    var html =
      '<div><img src="' +
      $rootScope.urlS3 +
      '/users/' +
      vm.showcase.img +
      '" class="avatar avatar-original" style="-webkit-user-select:none; width: 158px; height: 158px;"><br><h2>Remove showcase</h2><h4>Are you sure?</h4></div>'

    swal(
      {
        title: '',
        type: '',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
        text: html,
        html: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.deleteShowcase(vm.showcase.id).then(
            function () {
              vm.showcase.img = undefined
              load()
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.resetRank = function () {
    swal(
      {
        title: 'Are you sure?',
        text: 'This action will reset all ranks of user',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'Reset',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.resetRank(vm.model.id).then(
            function () {
              toastr.success('Reset done')
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.exportUser = function () {
    CsvService.validSafari()
    UsersService.listDevices($stateParams.parentId, vm.oldPage, vm.currentPage, vm.sortType).then(
      function (result) {
        var listCsv = []
        var devices = ''
        for (var i = 0; i < result.results.length; i++) {
          devices += result.results[i]['id-d'] + ', '
        }

        var bday = '-'
        if (vm.model.bday !== undefined) {
          bday = vm.model.bday.split(',')
          var year = bday[1].replace(' ', '')
          var date = bday[0]
          bday = date + '-' + year
        }

        listCsv.push({
          id: vm.model.id,
          name: vm.model.name === undefined ? '-' : vm.model.name,
          username: vm.model.username === undefined ? '-' : vm.model.username,
          email: vm.model.email === undefined ? '-' : vm.model.email,
          age: vm.model.age === undefined ? '-' : vm.model.age,
          birthdate: bday,
          blurb: vm.model.blurb === undefined ? '-' : vm.model.blurb,
          devices: devices,
        })

        var csv = CsvService.convertArrayOfObjectsToCSV({
          data: listCsv,
          columnDelimiter: ',',
        })

        if (csv === null) {
          return
        }

        var pom = document.createElement('a')
        var csvContent = csv //here we load our csv data
        var blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;',
        })
        var url = URL.createObjectURL(blob)
        pom.href = url
        pom.setAttribute('download', vm.model.username + '.csv')
        pom.click()
      },
    )
  }

  vm.setShelfie = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
        confirmButtonText: 'Ok',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.setShelfie(parseInt($stateParams.parentId), {
            sf: !vm.model.sf,
          }).then(
            function (result) {
              vm.model.sf = result.results.sf
              toastr.success('Added to shelfie')
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  UsersService.listListingBuyer($stateParams.parentId, 0, 1).then(function (result) {
    vm.clbuy = result.ct
  })

  UsersService.listListingSeller($stateParams.parentId, 0, 1).then(function (result) {
    vm.clsell = result.ct
  })

  vm.encrypt = function (value) {
    var result = ''
    for (var i = 0; i < value.length; i++) {
      if (i < value.length - 1) {
        result += value.charCodeAt(i) + 10
        result += '-'
      } else {
        result += value.charCodeAt(i) + 10
      }
    }
    return result
  }

  vm.decrypt = function (value) {
    var result = ''
    var array = value.split('-')
    for (var i = 0; i < array.length; i++) {
      result += String.fromCharCode(array[i] - 10)
    }
    return result
  }

  vm.lockModel = null
  vm.lockReasons = [
    { id: 0, name: 'Unspecified' },
    { id: 1, name: 'ChargeBack' },
    { id: 2, name: 'Wash Trade' },
    { id: 3, name: 'Fraud' },
  ]

  vm.openLockModal = function () {
    $('#modalLockReason').modal('show')
  }

  vm.lock = function () {
    swal(
      {
        title: 'Lock user',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          UsersService.lockUser(vm.model.id, vm.lockModel).then(
            function () {
              swal.close()
              $('#modalLockReason').modal('hide')
              swal('User locked!')
              load()
            },
            function (err) {
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
              }
              $timeout(function () {
                swal({
                  title: 'Lock User',
                  text: html,
                  html: true,
                })
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.unlock = function () {
    swal(
      {
        title: 'unlock user',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $timeout(function () {
            UsersService.unlockUser(vm.model.id, null).then(
              function () {
                load()
                swal('User unlocked!')
              },
              function (err) {
                swal(err.error.message, '', 'error')
              },
            )
          }, 500)
        } else {
          return
        }
      },
    )
  }

  vm.resetKYC = function () {
    swal(
      {
        title: 'Reset KYC',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $timeout(function () {
            UsersService.resetKYC(vm.model.id).then(
              function () {
                load()
                swal('Reseted!')
              },
              function (err) {
                swal(err.error.message, '', 'error')
              },
            )
          }, 500)
        } else {
          return
        }
      },
    )
  }

  vm.isOpen = false
  vm.sora = null
  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openKYC = function () {
    $('#modalKYC').modal('show')
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.approveKYC = function () {
    var bday = vm.bday
    if (bday !== undefined && bday !== '' && bday !== null) {
      if (isDate(bday)) {
        var date = parseInt(new Date(bday).getTime() + '000')
        bday = date
        vm.sora['bday'] = bday
      }
    }

    vm.sora['id-u'] = vm.model.id

    swal(
      {
        title: 'Approve KYC',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $timeout(function () {
            UsersService.approveKYC(vm.model.id, vm.sora).then(
              function () {
                load()
                vm.sora = null
                $('#modalKYC').modal('hide')
                swal('Done!')
              },
              function (err) {
                swal(err.error.message, '', 'error')
              },
            )
          }, 500)
        }
      },
    )
  }
}
